import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'; 
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';


const languages = ['en', 'zh'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend : {
        //ns = namespace, lng = language
        loadPath: "/assets/i18n/{{ns}}/{{lng}}.json",
    },
    fallbackLng: 'en',
    debug: false,
    ns: ["home"],
    whitelist : languages,
    interpolation: {
        formatSeparator: ",",
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
        wait: true,
    },
  });


export default i18n;